import * as React from 'react';

/**
 * Checkbox Component - Material Design Responsive
 * 
 * Per copilot-instructions.md section 7B:
 * - Touch targets MUST be ≥ 48px on mobile
 * - Checkbox is wrapped in a touch target area
 */

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onCheckedChange?: (checked: boolean) => void;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, onCheckedChange, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onCheckedChange) {
        onCheckedChange(e.target.checked);
      }
      if (props.onChange) {
        props.onChange(e);
      }
    };

    return (
      <div className="inline-flex items-center justify-center min-h-[48px] min-w-[48px] sm:min-h-0 sm:min-w-0">
        <input
          type="checkbox"
          ref={ref}
          className={`h-5 w-5 sm:h-4 sm:w-4 rounded border-border text-primary focus:ring-primary/30 cursor-pointer ${className || ''}`}
          onChange={handleChange}
          {...props}
        />
      </div>
    );
  }
);
Checkbox.displayName = 'Checkbox';

export { Checkbox };
